import { render, staticRenderFns } from "./manage-nominations.vue?vue&type=template&id=cde275b0&"
import script from "./manage-nominations.vue?vue&type=script&lang=js&"
export * from "./manage-nominations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports